import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { sendValidation } from '../../../services/userService';
import { logo } from '../../imagepath';

const ValidationEmail = () => {
  const { token } = useParams(); 
  const [activationToken, setActivationToken] = useState(token === "null" ? '' : token);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (token && token !== "null") {
      handleSubmit(); 
    }
  }, [token]);

  const handleChange = (e) => {
    setActivationToken(e.target.value);
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();
    try {
      const response = await sendValidation(activationToken);
      if (response.status === 'OK') {
        setSuccess(response.message);
        setError(null);
      } else {
        setError(response.message);
        setSuccess(null);
      }
    } catch (error) {
      setError(error.message);
      setSuccess(null);
    }
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      <div className="flex-grow-1">
        <div className="container-fluid">
          <div className="row min-vh-100 justify-content-center align-items-center">
            <div className="col-12 col-sm-8 col-md-6 col-lg-4 mt-5">
              {/* Logo kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-3 mb-4 d-flex justify-content-center">
                <Link to="/home">
                  <img src={logo} className="img-fluid" alt="Logo" style={{ maxHeight: 50 }} />
                </Link>
              </div>
              {/* Form kutusu */}
              <div className="bg-light rounded-4 shadow-sm p-4">
                <h4 className="fw-semibold mb-2 text-center text-darkfume ">Kullanıcı Doğrulama</h4>
                <hr className="mb-4 mt-0" />
                <form onSubmit={handleSubmit}>
                  <div className="input-block">
                    <label className="form-control-label text-darkfume text-sm">Aktivasyon Kodu</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Aktivasyon Kodunu Girin"
                      value={activationToken}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {error && <p style={{ color: "red" }}>{error}</p>}
                  {success && <p style={{ color: "green" }}>{success}</p>}
                  <div className="d-grid">
                    <button className="btn btn-primary text-sm" type="submit">
                      Doğrula
                    </button>
                  </div>
                </form>
                <div className="text-sm text-center mt-4">
                  <p className="mb-0">
                    <Link className="text-blue me-3" to="/login">Giriş Yap</Link>
                    <Link className="text-blue" to="/register">Kayıt Ol</Link>
                  </p>
                </div>
              </div>
              <footer className="w-100 text-center mt-4 mb-2">
                <small className="text-secondary">
                  © 2025 Ideal Online &middot;
                  <Link to="/support" className="text-secondary text-decoration-none mx-1">Destek</Link> &middot;
                  <Link to="/kvkk" className="text-secondary text-decoration-none mx-1">KVKK</Link> &middot;
                  <Link to="/help" className="text-secondary text-decoration-none mx-1">Yardım</Link>
                </small>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValidationEmail;
